module.exports = __webpack_public_path__ + "img/example1.6f05d46d.png";